import { render, staticRenderFns } from "./dg-copyright.vue?vue&type=template&id=11be77f3&scoped=true"
import script from "./dg-copyright.vue?vue&type=script&lang=js"
export * from "./dg-copyright.vue?vue&type=script&lang=js"
import style0 from "./dg-copyright.vue?vue&type=style&index=0&id=11be77f3&prod&lang=less&scoped=true"
import style1 from "./dg-copyright.vue?vue&type=style&index=1&id=11be77f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11be77f3",
  null
  
)

export default component.exports